/**
 * maxAge
 * @description validate userInput for max age (16,18,21)
 * @return {Boolean}
 */
const maxAge = {
	getMessage: (field, args) => `Age must be younger than ${args[0]} years old`,
	validate: (value, args) => {
		const age = args[0]
		const userDate = new Date(value)
		const now = new Date() // should fetch from server but lets do this locally

		const compareDate = new Date(
			now.getFullYear() - age,
			now.getMonth(),
			now.getDate()
		)
		return compareDate < userDate
	},
	immediate: true
}

/**
 * must Travel
 * @description
 */
const mustTravel = {
	getMessage: (field, args) => `Proposer must travel for policy to be valid`,
	validate: (value, args) => value === true || value === "true",
	immediate: true
}

// helper functions
const lt = (comparison, input) => comparison < input
// const lte = (comparison, input) => comparison <= input;
// const gt  = (comparison, input) => comparison > input;
const gte = (comparison, input) => comparison >= input

/**
 * age_lt
 */
const age_lt = {
	getMessage: (field, args) => `Age must be less than ${args[0]}`,
	validate: (value, args) => {
		const age = args[0]
		const userDate = new Date(value)
		userDate.setHours(0)
		const now = new Date() // should fetch from server but lets do this locally

		const compareDate = new Date(
			now.getFullYear() - age,
			now.getMonth(),
			now.getDate()
		)
		return lt(compareDate, userDate)
	}
}

/**
 * age_lte
 */
const age_lte = {
	getMessage: (field, args) => `Age must be less than or equal to ${args[0]}`,
	validate: (value, args) => {
		const age = args[0]
		const userDate = new Date(value)
		userDate.setHours(0)
		const now = new Date() // should fetch from server but lets do this locally

		const compareDate = new Date(
			now.getFullYear() - (age + 1),
			now.getMonth(),
			now.getDate()
		)
		return lt(compareDate, userDate)
	}
}

/**
 * age_gt
 */
const age_gt = {
	getMessage: (field, args) => `Age must be greater than ${args[0]}`,
	validate: (value, args) => {
		const age = args[0]
		const userDate = new Date(value)
		userDate.setHours(0)
		const now = new Date() // should fetch from server but lets do this locally

		const compareDate = new Date(
			now.getFullYear() - (age + 1),
			now.getMonth(),
			now.getDate()
		)
		return gte(compareDate, userDate)
	}
}

/**
 * age_gte
 */
const age_gte = {
	getMessage: (field, args) =>
		`Age must be greater than or equal to ${args[0]}`,
	validate: (value, args) => {
		const age = args[0]
		const userDate = new Date(value)
		userDate.setHours(0)
		const now = new Date() // should fetch from server but lets do this locally

		const compareDate = new Date(
			now.getFullYear() - age,
			now.getMonth(),
			now.getDate()
		)
		return gte(compareDate, userDate)
	}
}

/**
 * age_eq
 * @description check if age is explictly equal
 * @example age_eq: 18
 *   Today's date is 2018/08/02
 *   valid input range:
 *      1. 1999/08/03
 *      2. 2000/08/02
 *   invalid
 *      1. 1999/08/02 (age is 19)
 *      2. 2000/08/03 (age is 17)
 */
const age_eq = {
	getMessage: (field, args) => `Age must equal to ${args[0]}`,
	validate: (value, args) => {
		const age = args[0]
		const userDate = new Date(value)
		userDate.setHours(0)
		const now = new Date() // should fetch from server but lets do this locally

		const lowerBoundaryDate = new Date(
			now.getFullYear() - age,
			now.getMonth(),
			now.getDate()
		)
		const upperBoundaryDate = new Date(
			now.getFullYear() - (age + 1),
			now.getMonth(),
			now.getDate()
		)

		return gte(lowerBoundaryDate, userDate) && lt(upperBoundaryDate, userDate)
	}
}

/**
 * age_between
 * @description check if age is between two ages
 * @example age_between: [18, 20]
 *   Today's date is 2018/08/02
 *   valid input range:
 *      1. 1997/08/03 (age is 20)
 *      2. 1998/08/02 (age is 20)
 *      3. 1998/08/03 (age is 19)
 *      4. 2000/08/02 (age is 18)
 *   invalid
 *      1. 1997/08/02 (age is 21)
 *      2. 2000/08/03 (age is 17)
 */
const age_between = {
	getMessage: (field, args) => `Age must be between ${args[0]} and ${args[1]}`,
	validate: (value, args) => {
		const lowerAge = args[0]
		const upperAge = args[1]
		const userDate = new Date(value)
		userDate.setHours(0)
		const now = new Date() // should fetch from server but lets do this locally

		const lowerBoundaryDate = new Date(
			now.getFullYear() - lowerAge,
			now.getMonth(),
			now.getDate()
		)
		const upperBoundaryDate = new Date(
			now.getFullYear() - (upperAge + 1),
			now.getMonth(),
			now.getDate()
		)

		return gte(lowerBoundaryDate, userDate) && lt(upperBoundaryDate, userDate)
	},
	immediate: true
}

/**
 * hkid
 * @description validate userInput for validate hkid
 */
const hkid = {
	getMessage: field => `The submitted value is not a valid HKID`,
	validate: value => value.match(/^([A-Z]{1,2})([0-9]{6})([A0-9])$/gi) !== null,
	immediate: true
}

/**
 * noChinese
 * @description use unicode to find chinese character range and invalidate user input
 */
const noChinese = {
	getMessage: field =>
		`The ${field} value should not contain Chinese characters`,
	validate: value =>
		value.match(/[\u2E80-\u2FD5\u3400-\u4DBF\u4E00-\u9FCC]/gi) === null
}

/**
 * alpha_underscore
 * @description only alpha characters and underscores allowed
 */
const alphanumeric_underscore = {
	getMessage: field => `This field is not valid`,
	validate: value => value.match(/^[a-z0-9_]+$/g) !== null,
	immediate: true
}

export default {
	age_between,
	age_eq,
	age_gt,
	age_gte,
	age_lt,
	age_lte,

	hkid,
	maxAge,
	mustTravel,

	noChinese,
	alphanumeric_underscore
}
